// extracted by mini-css-extract-plugin
module.exports = {"brand":"Brand-module--brand--1H0fM","logo":"Brand-module--logo---YpUd","logoImg":"Brand-module--logoImg--3_A6d","text":"Brand-module--text--1_9nS"};